import groq from 'groq'
import { imageFragment } from './image'

export const muxVideoFragment = groq`
  asset->,
`

export const videoSettingsFragment = groq`
  settings {
    controls,
    autoplay,
    autoplayOnHover,
    openModalOnClick,
    loop,
    muted,
  },
`

export const videoAspectRatioFragment = groq`
  aspectRatio {
    custom,
    base,
    sm,
    md,
    lg,
    xl,
  },
`

export const videoFragment = groq`
  type,
  muxVideo {
    ${muxVideoFragment}
  },
  ${videoSettingsFragment}
  ${videoAspectRatioFragment}
  thumbnailImage {
    ${imageFragment}
  },
  borderRadius,
`
